import { render, staticRenderFns } from "./myWorkFj.vue?vue&type=template&id=27ba7b4a&scoped=true&"
import script from "./myWorkFj.vue?vue&type=script&lang=js&"
export * from "./myWorkFj.vue?vue&type=script&lang=js&"
import style0 from "./myWorkFj.vue?vue&type=style&index=0&id=27ba7b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ba7b4a",
  null
  
)

export default component.exports